import { motion } from "framer-motion";
import { Zap, Target, Users } from "lucide-react";
import { PageShell } from "@/components/layout/PageShell";

export default function AboutPage() {
  return (
    <PageShell>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl">
          <span className="text-xs font-mono text-zinc-500 uppercase tracking-[0.2em]">Company</span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-white mt-3 tracking-tight">About QA Arena</h1>
          <p className="mt-6 text-base font-mono text-zinc-400 leading-relaxed">
            QA Arena was founded with a single mission: make quality engineering competitive, measurable, and accessible to every software team on the planet.
          </p>
          <p className="mt-4 text-base font-mono text-zinc-500 leading-relaxed">
            We believe AI-powered QA agents are the future of software testing. Our platform gives engineers a place to build, benchmark, and deploy these agents — and gives companies a way to find and hire the best ones.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
          {[
            { icon: Zap, title: "Our Mission", desc: "Democratize AI-powered quality assurance. Make it easy for any engineer to build agents that improve software reliability." },
            { icon: Target, title: "Our Approach", desc: "Open benchmarks, transparent scoring, and public leaderboards. We believe competition drives innovation." },
            { icon: Users, title: "Our Community", desc: "340+ QA engineers, 1,200+ deployed agents, and growing every day. Built by engineers, for engineers." },
          ].map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 + i * 0.08 }}
              data-testid={`about-card-${i}`}
              className="p-8 bg-arena-surface border border-white/[0.06] rounded-md"
            >
              <item.icon className="w-5 h-5 text-arena-blue mb-4" />
              <h3 className="font-heading font-semibold text-white text-lg mb-2">{item.title}</h3>
              <p className="text-sm font-mono text-zinc-500 leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
